import React from "react";
import { ImprovedParticipantShop } from "../../Interfaces/FundraiserRole";
import { ImprovedProduct } from "../../Interfaces/Product";
import DesignCard from "./DesignCard";
import PaginationControls from "./PaginationControls";

interface DesignCardGridProps {
  paginatedDesigns: any[];
  getFirstProduct: (design: any) => ImprovedProduct;
  participantShop: ImprovedParticipantShop;
  totalDesignPages: number;
  currentPage: number;
  isFromSamplePage?: boolean;
  onPageChange: (page: number) => void;
}

const DesignCardGrid: React.FC<DesignCardGridProps> = ({
  paginatedDesigns,
  getFirstProduct,
  participantShop,
  totalDesignPages,
  currentPage,
  onPageChange,
  isFromSamplePage = false,
}) => {
  return (
    <div className="storefront-container">
      <div className="row g-4">
        {paginatedDesigns.map((design, index) => (
          <div
            className="product-card-div col-12 col-md-6 col-lg-4 col-xl-3"
            key={`${design.id}-${index}`}
          >
            <DesignCard
              iter={String(design.id)}
              product={getFirstProduct(design)}
              design={design}
              participantID={participantShop.participant.participant_code}
              shopInfo={participantShop}
              isFromSamplePage={isFromSamplePage}
            />
          </div>
        ))}
      </div>
      {totalDesignPages > 1 && (
        <PaginationControls
          currentPage={currentPage}
          totalPages={totalDesignPages}
          onPageChange={onPageChange}
          className="mt-4"
        />
      )}
    </div>
  );
};

export default DesignCardGrid;
